import { Component } from '@angular/core';
import { categoryNames } from '@realwear-cloud/app-marketplace/shared';

@Component({
  selector: 'realwear-cloud-app-not-found',
  templateUrl: './app-not-found.component.html',
  styleUrls: ['./app-not-found.component.scss']
})
export class AppNotFoundComponent {
  readonly categories: string[] = categoryNames;
}
